module.exports = __webpack_public_path__ + "media/images/map_icons/Poker-0ff549fa4f5915447cebe03889413614.svg";